import script from "./form-group.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./form-group.vue?vue&type=script&setup=true&lang=js"
export * from "./form-group.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./form-group.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__